/* eslint-disable @typescript-eslint/no-misused-promises */
import { useSeekaConverge } from "@seeka-labs/converge-react";
import { Box, PrimaryButton, Stack, Text } from "flicket-ui";
import { useLocalStorage } from "usehooks-ts";
import CustomModal from "~components/CustomModal";
import { WaitlistForm, waitlistFormId } from "~components/events/waitlist";
import { WaitListFormValues } from "~components/events/waitlist/interface";
import { useAccount, useOrganization } from "~hooks";
import { useReCaptchaSDK } from "~hooks/useReCaptcha";
import { useReferralCode } from "~hooks/useReferralCode";
import { handleRegistrationFormSubmit } from "~pages/events/[eventId]/registration";
import { PageContext } from "../hooks/useDetailsPageContext";

export const getRegistrationFormValueLocalStorage = (releaseId: string) => ({
  key: `registration-form-value-${releaseId}`,
  defaultValue: {
    firstName: undefined,
    lastName: undefined,
    email: undefined,
    phoneNumber: undefined,
    usableForMarketing: undefined,
    customFields: [],
  } as WaitListFormValues,
});

export const RegistrationModalContent = ({
  pageContext,
}: {
  pageContext: PageContext;
}) => {
  const { recaptchaSdkGenerator } = useReCaptchaSDK();
  const { referralCode, referralCodeVersion } = useReferralCode();
  const { hasFeature, organization } = useOrganization();
  const { revaildateUser } = useAccount();
  const { event, setUserEmail } = pageContext;
  const converge = useSeekaConverge();

  const isPrePurchaseActive =
    event.presaleRelease?.isPrePurchaseActive &&
    hasFeature("prePurchaseRegistration");

  const { defaultValue, key } = getRegistrationFormValueLocalStorage(
    event.presaleRelease?.id
  );

  const [, setFormValues] = useLocalStorage(key, defaultValue);

  return (
    <>
      <CustomModal.Header>Register for presale notification</CustomModal.Header>
      <CustomModal.Content>
        <Stack direction={"vertical"} gap={3}>
          <Text variant="regular">
            Register to get early access to presale tickets as soon as they go
            live.
          </Text>
          <Box width="100%">
            <WaitlistForm
              waitlistType="registration"
              handleSubmit={async (values, actions) => {
                await handleRegistrationFormSubmit(
                  values,
                  actions,
                  {
                    organization,
                    recaptchaSdkGenerator,
                    referralCode,
                    referralCodeVersion,
                    converge,
                    revaildateUser,
                    event,
                  },
                  (data) => {
                    setUserEmail(values.email);
                    pageContext.setWaitlistUserId(data?.joinWaitlist?.id);
                    pageContext.setActiveModal("registration-success");

                    if (isPrePurchaseActive) {
                      setFormValues(values);
                    }
                  }
                );
              }}
              presaleInformation={event?.presaleInformation}
              customFields={event?.customFields?.filter((customField) =>
                customField.targetArea.includes("registration")
              )}
              hideSubmitButton
            />
          </Box>
        </Stack>
      </CustomModal.Content>
      <CustomModal.Footer>
        <PrimaryButton type="submit" form={waitlistFormId}>
          Notify me when presale opens
        </PrimaryButton>
      </CustomModal.Footer>
    </>
  );
};
